'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import type { FormError } from '../../../utils/volunteer-utils.ts';
export interface VolunteerErrorsProps {
  errors: FormError[];
}

/** Translates and renders the sheet's form-level errors, one Alert each. */
export const VolunteerErrors: React.FC<VolunteerErrorsProps> = t0 => {
  const $ = _c(8);
  const {
    errors
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["volunteers"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  if (errors.length === 0) {
    return null;
  }
  let t2;
  if ($[1] !== errors || $[2] !== t) {
    let t3;
    if ($[4] !== t) {
      t3 = (error, i) => <Alert key={`${error.type}-${i}`} variant="negative" message={t(error.key, error.params)} />;
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = errors.map(t3);
    $[1] = errors;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="flex flex-col gap-snug-lg pb-comfy-sm">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};